import { isObject } from './is-object';
export function isJSBlock(data) {
  if (!isObject(data)) {
    return false;
  }
  return data.type === 'JSBlock';
}